/* eslint-disable import/prefer-default-export */
export const omitEmptyParams = (
  obj: unknown,
  options: {
    trimStrings?: boolean;
    omitEmptyArrays?: boolean;
    omitEmptyObjects?: boolean;
    omitZero?: boolean;
    omitFalse?: boolean;
  } = {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, any> => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return {};
  }

  const {
    trimStrings = true,
    omitEmptyArrays = true,
    omitEmptyObjects = false,
    omitZero = false,
    omitFalse = false,
  } = options;

  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value === null || value === undefined) {
      return acc;
    }

    if (typeof value === 'string') {
      const trimmedValue = trimStrings ? value.trim() : value;
      if (trimmedValue === '') {
        return acc;
      }
    }

    if (omitEmptyArrays && Array.isArray(value) && value.length === 0) {
      return acc;
    }

    if (
      omitEmptyObjects &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      Object.keys(value).length === 0
    ) {
      return acc;
    }

    if (omitZero && value === 0) {
      return acc;
    }

    if (omitFalse && value === false) {
      return acc;
    }

    acc[key] = value;

    return acc;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as Record<string, any>);
};
